export default "__VITE_PUBLIC_ASSET__b46c9320__"